import React from "react";

import cx from "classnames";

import { coalesce } from "@kazoohr/helpers";

import { Icon } from "../Icon";
import { ProfilePic } from "../ProfilePic";

import type { User } from "./types";
import styles from "./UserMenu.scss";

interface UserMenuButtonProps {
  className?: string;
  testid: string;
  isOpen: boolean;
  user?: User | null;
  setOpen: (isOpen: boolean) => void;
  isPreview?: boolean;
}

export function UserMenuButton({
  className,
  testid,
  isOpen,
  user,
  setOpen,
  isPreview,
}: UserMenuButtonProps) {
  if (!user) {
    return null;
  }

  const buttonStyles = cx(className, styles["user-menu__button"], {
    "layout-header-foreground": !isOpen,
    [styles["user-menu__button--open"]]: isOpen,
  });

  const title = coalesce(user.title, user.jobTitle);

  return (
    <button
      className={buttonStyles}
      onClick={() => setOpen(!isOpen)}
      aria-haspopup="listbox"
      aria-expanded={isOpen}
      data-testid={testid}
      disabled={isPreview}
      type="button"
      title={`${name}${title ? `, ${title}` : ""}`}
    >
      <div className={styles["user-menu_button-wrapper"]}>
        <div className={styles["user-menu__profile-pic"]}>
          <ProfilePic user={user} dimensions={32} />
        </div>
        <div className={styles["user-menu__info"]}>
          <div className={styles["user-menu__info__name"]}>{user.name}</div>
          {title && (
            <div className={styles["user-menu__info__job-title"]}>{title}</div>
          )}
        </div>
        {!isPreview && (
          <div className={styles["user-menu__caret"]}>
            <Icon
              icon={isOpen ? "caret_up" : "caret_dn"}
              size={12}
              color={isOpen ? styles.defaultText : "currentColor"}
            />
          </div>
        )}
      </div>
    </button>
  );
}
